var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"videoElem"}},[_c('span',[_vm._v("Shiyun")]),_c('video',{attrs:{"autoplay":"","playsinline":"","src":this.videoSource,"id":"videoBot"},on:{"ended":function($event){return _vm.changeSource()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }